export default {
  methods: {
    // 发送验证码倒计时
    sendCodeCounter() {
      const timeCounterCont = 'Resend(===)';
      const timeStart = +new Date();
      this.btnCodeCanClick = false;
      const counter = () => {
        const time = 60000 - +new Date() + timeStart;
        if (time < 0) {
          this.countTxt = 'Resend';
          this.btnCodeCanClick = true;
        } else {
          /* eslint-disable-next-line */
          this.countTxt = timeCounterCont.replace(
            /===/,
            Math.floor(time / 1000)
          );
          setTimeout(function() {
            counter();
          }, 1000);
        }
      };
      counter();
    }
  }
};
